import Card from "../../components/Card";
import Modal from "../../components/Modal";
import styles from "./UpsAccount.module.sass";
import {
	ShipAccountCreate,
	ShipAccountDelete,
	ShipAccountGet,
} from "../../Services/lib/shipping";
import { UseApi } from "../../hooks/use-api";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { useEffect, useState } from "react";
import Disclaimer from "../../components/Disclaimer";
import TextInput from "../../components/TextInput";
import classNames from "classnames";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import Loader from "../../components/Loader";
import Empthy from "../../components/Empty";
import redeem from "../../i11/Redeem";
import { useUser } from "../../context";

const UPSAccount = ({ isOpen: isOpen_, onClose: onClose_ }) => {
	const { locale } = useUser();
	const [{ data, isLoading }, getList] = UseApi({
		service: ShipAccountGet,
	});

	const { isOpen, onClose, onOpen } = UseDisclosure();

	const close = () => {
		onClose();
		onClose_();
	};

	useEffect(() => {
		getList();
	}, []);

	return (
		<>
			<Modal
				outSideClickNone
				outerClassName={styles.outer}
				visible={isOpen_}
				onClose={close}
			>
				<Card
					className={styles.card}
					title={redeem[locale].account_list}
					classTitle="title-red"
					head={
						<button onClick={onOpen} className="button-small">
							{redeem[locale].add_account}
						</button>
					}
				>
					{isLoading ? (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					) : (
						data &&
						(data.length > 0 ? (
							data.map((e) => {
								return <Row getList={getList} key={e._id} data={e} />;
							})
						) : (
							<Empthy />
						))
					)}
				</Card>
			</Modal>
			{isOpen && (
				<Modal visible={isOpen} onClose={onClose}>
					<Create getList={getList} />
				</Modal>
			)}
		</>
	);
};

const Row = ({ data, getList }) => {
	const [{ isLoading }, delete__] = UseApi({
		service: ShipAccountDelete,
	});

	const delete_ = async () => {
		const res = await delete__(data._id);
		if (res) {
			getList();
			ToastEmitter({
				type: "success",
				msg: "Successfully deleted account",
			});
		}
	};

	const { locale } = useUser();

	return (
		<div className={styles.row}>
			<div>{data.countryCode}</div>
			<div>-</div>
			<div>{data.upsCredentials.accountNumber}</div>
			<button
				onClick={delete_}
				className={classNames("button-small button-stroke-red", {
					disabled: isLoading,
				})}
			>
				{isLoading && <Loader />}
				{redeem[locale].delete}
			</button>
		</div>
	);
};

const Create = ({ getList }) => {
	const [state, setState] = useState({
		clientId: "",
		clientSecret: "",
		accountNumber: "",
		countryCode: "",
	});

	const [{ isLoading }, createAccount] = UseApi({
		service: ShipAccountCreate,
	});

	const handler = (name, e) => {
		setState((p) => {
			return {
				...p,
				[name]: e,
			};
		});
	};

	const submitHandler = async (e) => {
		e.preventDefault();
		const res = await createAccount(state);
		if (res) {
			setState({
				clientId: "",
				clientSecret: "",
				accountNumber: "",
				countryCode: "",
			});
			getList();
			ToastEmitter({
				type: "success",
				msg: "Successfully added new account",
			});
		}
	};

	const { locale } = useUser();

	return (
		<Card title={redeem[locale].add_account} classTitle="title-red">
			<form onSubmit={submitHandler} className={styles.grid}>
				<Disclaimer>
					{redeem[locale].disclaimer}
					<br />
					<a target="_blank" href="https://developer.ups.com/" rel="noreferrer">
						https://developer.ups.com/
					</a>
				</Disclaimer>
				{Object.keys(state).map((e) => {
					return (
						<TextInput
							onInvalid={(ev) =>
								ev.target.setCustomValidity(
									redeem[locale].dictionary[e].validation.default
								)
							}
							placeHolder={redeem[locale].dictionary[e].holder}
							required
							value={state[e]}
							onChangeInput={(val) => {
								handler(e, val);
							}}
							label={redeem[locale].dictionary[e].label}
							key={e}
						/>
					);
				})}
				<div className={styles.buttonContainer}>
					<button
						className={classNames("button-small", { disabled: isLoading })}
					>
						{isLoading && <Loader />}
						{redeem[locale].save}
					</button>
				</div>
			</form>
		</Card>
	);
};

export default UPSAccount;
